module.exports = __webpack_public_path__ + "img/in_installation.8b7b6946.svg";